import React, { useEffect } from 'react';
import { useOnTopNotification } from '@increasecard/increase-core';
import { LoadableStatus } from '@card/types';
import { useProblemCredentialsCount } from './useProblemCredentialsCount';
import { BlockedCredentialsAlert } from './BlockedCredentialsAlert';

export function useBlockedCredentialsAlert() {
  const problemCredentials = useProblemCredentialsCount();
  const { setOnTopNotification } = useOnTopNotification();
  useEffect(() => {
    if (problemCredentials.status !== LoadableStatus.Fetched) return;
    const count = problemCredentials.data;
    if (count === 0) return;

    setOnTopNotification({
      children: <BlockedCredentialsAlert count={count} />,
      variant: 'error'
    });
  }, [problemCredentials, setOnTopNotification]);
}
